export class LoginBody {
    username: string;
    password: string;
}